import { render, staticRenderFns } from "./LoanInfo.vue?vue&type=template&id=0ce4da34&scoped=true&"
import script from "./LoanInfo.vue?vue&type=script&lang=js&"
export * from "./LoanInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce4da34",
  null
  
)

export default component.exports